import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ButtonModule } from 'primeng/button';
import { ChecklistGroup, ChecklistItem, ChecklistResponse } from '../../../interfaces/checklist.model';
import { PDFFormConfig } from '../../../interfaces/config';
import { CheckListService } from '../../../services/check-list.service';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AccordionComponent } from '@ppl/ui';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { ModalComponent } from '@ppl/ui';
import { IC_PROVIDER_CLASSIFICATION_FORM, VE_PROVIDER_CLASSIFICATION_FORM, PROVIDER_TYPES, RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { LoggerService } from '../../../shared/services/logger.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { EditpdfComponent } from '../../editpdf/editpdf.component';
import { ChecklistViewComponent } from "../checklist-view/checklist-view.component";
import { CommPreferenceComponent } from '../comm-preference/comm-preference.component';
import { ChecklistHelperService } from '../../../services/checklist.helper.service';
import { PopupDialogComponent } from '@ppl/ui';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'ppl-provider-checklist',
  standalone: true,
  imports: [ListTableComponent, CommonModule, NgZorroModule, ReactiveFormsModule, AccordionComponent,
    ButtonComponent, NzCollapseModule,
    CommPreferenceComponent,
    CommonModule, ButtonModule,
    NzToolTipModule,
    NzRadioModule,
    NzButtonModule,
    ButtonComponent,
    ModalComponent,
    EditpdfComponent,
    ChecklistViewComponent,
    FormsModule,
    PopupDialogComponent
  ],
  templateUrl: './provider-checklist.component.html',
  styleUrl: './provider-checklist.component.css'
})
export class ProviderChecklistComponent extends BaseComponent implements OnInit {
  prvdrAssociations: any = [];
  associationDetailsData: any = {};

  cols: any[] = [];
  selectedOption = '';
  date = '';
  checklistData: ChecklistGroup[] = [];
  providerAssociationChecklist?: ChecklistGroup[] = [];
  radioOptions = RADIO_YES_NO_OPTIONS;
  showAssociationModal = false;
  showPdfViewerModal = false;
  modalBody = {
    associationModal: '',
    pdfViewerModal: ''
  };
  program: any;
  pdfFile?: string;
  pdfBlob?: Blob;
  pdfConfig?: PDFFormConfig;
  leadId = '';
  associatedPPLId?: string;
  selectedParticipantId?: number;
  selectedProviderType?: string;
  selectedForm: any;
  @Input() isEditable = true;
  selectedparticipant: any;

  // ── Employer ⇄ Provider checklist accordions ────────────────────────────────
  // Self type(s) of the current provider (from checklist details where associationId === -1).
  // Employer (EMP)  → show "Checklist for Providers" (EMPLOYERPROVIDER APIs, userType EMP).
  // Independent Provider (IR) → show "Checklist for Employers" (PROVIDEREMPLOYER APIs, userType IR).
  isEmployerProvider = false;
  isIndependentProvider = false;
  employerProviderList: any[] = [];   // rows for "Checklist for Providers"
  providerEmployerList: any[] = [];   // rows for "Checklist for Employers"
  linkedChecklist?: ChecklistGroup[] = [];
  showLinkedModal = false;
  linkedModalTitle = '';
  selectedLinkedRow: any;
  selectedLinkedMode: 'employerProvider' | 'providerEmployer' | null = null;

  employerProviderCols: any[] = [
    { field: 'prvName', header: 'Provider Name', jsonpath: 'prvName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'prvPplId', header: 'Provider PPL ID', jsonpath: 'prvPplId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'empName', header: 'Employer', jsonpath: 'empName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'empPplId', header: 'Employer PPL ID', jsonpath: 'empPplId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];
  providerEmployerCols: any[] = [
    { field: 'empName', header: 'Employer Name', jsonpath: 'empName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'empPplId', header: 'Employer PPL ID', jsonpath: 'empPplId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'prvName', header: 'Provider', jsonpath: 'prvName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'prvPplId', header: 'Provider PPL ID', jsonpath: 'prvPplId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];

  actions: any = {
    "edit": false,
    "delete": false,
    "view": true,
    "download": false,
    "verify": false,
    "add": false
  }
  entry: string | null = '';

  constructor(
    private sectionsService: SectionsService,
    private referralDataService: ReferralDataService,
    private enrollmentDataService: EnrollmentDataService,
    private logger: LoggerService,
    private referralService: ReferralDataService,
    private checkListService: CheckListService,
    private checklistHelperService: ChecklistHelperService,
    private userService: UserService,
    private storageService: StorageService
  ) {
    super();
  }

  activeKeys: string[] = ['1', '2', '3', '4', '5', '6', '7'];
  allPanelsExpanded = false;
  isParticipantFlow = false;
  userId = '';
  source = '';
  signature: any;
  signatureId: any;
  isSignAdded = false;
  showSignature: boolean = false;

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.program = this.userService.getSelectedProgram();
    this.leadId = this.userService.getSelectedLead() || '';
    const steps = this.sectionsService.getSectionData(this.program.program_code);
    this.secData = steps['associations'];
    this.userId = this.storageService.getParticipantId() || this.storageService.getProviderId() || this.userService.getSelectedLead() || '';
    this.isParticipantFlow = this.userService.getLeadEntry() == 'participantEnrollment' || this.sectionsService.getFlow() == 'participantEnrollment';
    this.source = this.isParticipantFlow ? 'participant' : 'provider';

    this.getGridHeaders();
    this.getChecklist(false);
    this.getSignature(this.program.program_code, this.source, this.userId);
    this.getAssociationDetails();
    this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
      this.getAssociationDetails();
    })
  }

  getSignature(program_code: string, type: string, id: string | null) {
    this.referralService.getSignature(program_code, type, id).subscribe((data: any) => {
      if (data?.responsedata && data?.responsedata.length) {
        const activeSign = data?.responsedata.find((data: any) => data.isActive);
        this.isSignAdded = true;
        this.signature = `data:image/png;base64,${activeSign?.signatureImageBase64}`;
        this.signatureId = this.isParticipantFlow ? activeSign.participantSignatureId : activeSign.providerSignatureId;
      }
    })
  }

  getChecklist(isAfterUpdate: boolean) {
    this.checkListService.getChecklist(this.program?.program_code, this.leadId || '', false, isAfterUpdate).subscribe((data: any) => {
      if (data.responsedata) {
        const checklist: ChecklistResponse = data.responsedata;
        this.checklistData = this.checklistHelperService.buildChecklistDataForProvider(this.filterHiddenItems(checklist.checkList), null, false, true);
        this.resolveSelfTypesAndLoadLinkedLists();
        this.expandAll();
      }
    });
  }

  // Provider Classification is captured by its own questionnaire (ppl-provider-classification),
  // so it must never surface as a checklist item.
  private filterHiddenItems(items: ChecklistItem[]): ChecklistItem[] {
    return (items ?? []).filter(item => item.formMasterId !== IC_PROVIDER_CLASSIFICATION_FORM.formMasterId && item.formMasterId !== VE_PROVIDER_CLASSIFICATION_FORM.formMasterId);
  }

  // Determine the provider's own type(s) from checklist "self" details (associationId === -1),
  // then load the Employer⇄Provider lists only for the applicable type.
  private resolveSelfTypesAndLoadLinkedLists() {
    const selfTypes = new Set<string>();
    this.collectSelfTypes(this.checklistData, selfTypes);
    this.isEmployerProvider = selfTypes.has('EMP');
    this.isIndependentProvider = selfTypes.has('IR');

    if (this.isEmployerProvider) {
      this.checkListService.getEmployerProviderList(this.program?.program_code, this.leadId || '').subscribe((res: any) => {
        this.employerProviderList = Array.isArray(res?.responsedata) ? res.responsedata : (res?.responsedata?.list ?? []);
      });
    }
    if (this.isIndependentProvider) {
      this.checkListService.getProviderEmployerList(this.program?.program_code, this.leadId || '').subscribe((res: any) => {
        this.providerEmployerList = Array.isArray(res?.responsedata) ? res.responsedata : (res?.responsedata?.list ?? []);
      });
    }
  }

  private collectSelfTypes(groups: ChecklistGroup[] | undefined, acc: Set<string>) {
    for (const g of groups ?? []) {
      for (const item of g.items ?? []) {
        (item.details ?? []).forEach((d: any) => {
          if (d.associationId == -1 && d.type) acc.add(d.type);
        });
      }
      this.collectSelfTypes(g.children, acc);
    }
  }

  employerProviderAction(event: { action: string; data: any }) {
    if (event.action === 'view') this.openLinkedChecklist('employerProvider', event.data);
  }

  providerEmployerAction(event: { action: string; data: any }) {
    if (event.action === 'view') this.openLinkedChecklist('providerEmployer', event.data);
  }

  openLinkedChecklist(mode: 'employerProvider' | 'providerEmployer', row: any) {
    this.selectedLinkedMode = mode;
    this.selectedLinkedRow = row;
    this.showLinkedModal = true;

    if (mode === 'employerProvider') {
      // current provider is the Employer; the row's provider (prvId) is the target. userType = EMP.
      this.linkedModalTitle = 'Provider - ' + row.prvName + ' (' + row.prvPplId + ')';
      this.checkListService
        .getEmployerProviderChecklist(this.program?.program_code, this.leadId || '', row.prvId, 'EMP')
        .subscribe((data: any) => this.buildLinkedChecklist(data, row));
    } else {
      // current provider is an IP; the row's employer (empId) is the target. userType = IR.
      this.linkedModalTitle = 'Employer - ' + row.empName + ' (' + row.empPplId + ')';
      this.checkListService
        .getProviderEmployerChecklist(this.program?.program_code, this.leadId || '', row.empId, 'IR')
        .subscribe((data: any) => this.buildLinkedChecklist(data, row));
    }
  }

  private buildLinkedChecklist(data: any, row: any) {
    if (data?.responsedata) {
      const checklist: ChecklistResponse = data.responsedata;
      // No participant selected in this flow → handleAssociationCheckListClick falls back to associatedPPLId for the PDF.
      this.associatedPPLId = checklist.pplId;
      this.linkedChecklist = this.checklistHelperService.buildChecklistDataForProvider(this.filterHiddenItems(checklist.checkList), row, false, false);
      this.linkedChecklist.forEach(group => {
        group.isActive = true;
        this.toggleCollapsePanel(group, true);
      });
    }
  }

  handleLinkedModalCancel() {
    this.showLinkedModal = false;
    this.linkedChecklist = undefined;
    this.selectedLinkedRow = undefined;
    this.selectedLinkedMode = null;
  }

  saveLinkedChecklist() {
    if (!this.linkedChecklist || !this.selectedLinkedRow || !this.selectedLinkedMode) return;
    const checklistItems = this.generateLinkedChecklistItems(this.linkedChecklist);

    if (this.selectedLinkedMode === 'employerProvider') {
      const payload = checklistItems;
      this.checkListService
        .saveEmployerProviderChecklist(this.program?.program_code, this.leadId || '', this.selectedLinkedRow.prvId, 'EMP', payload)
        .subscribe(() => this.openLinkedChecklist('employerProvider', this.selectedLinkedRow));
    } else {
      const payload = checklistItems;
      this.checkListService
        .saveProviderEmployerChecklist(this.program?.program_code, this.leadId || '', this.selectedLinkedRow.empId, 'IR', payload)
        .subscribe(() => this.openLinkedChecklist('providerEmployer', this.selectedLinkedRow));
    }
  }

  getAssociationDetails() {
    const isParticipant = this.entry === 'participantEnrollment';
    const participantId = !isParticipant ? this.storageService.getSelfEmployerParticipantId() : undefined;
    this.enrollmentDataService.getAssociationsDetails(this.program.program_code, this.leadId, isParticipant, false, participantId).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response.responsedata;
      if (isParticipant) {
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];
        }
      } else {
        this.prvdrAssociations = data.participantAssociations;
        this.prvdrAssociations.forEach((association: any) => {
          association.participantName = association.participantFirstName + ' ' + association.participantLastName;
        });

        // for (const checklist of this.prvdrAssociations) {
        //   if (checklist.checklistStatus == 'C') {
        //     checklist.checlistStatusText = "Completed"
        //   } else {
        //     checklist.checlistStatusText = "Not Completed"
        //   }
        // }

        this.prvdrAssociations = this.prvdrAssociations.filter((association: any) => association.associationStatus != 'Disassociated');

        console.log('this.prvdrAssociations', this.prvdrAssociations);
      }
    });
  }

  isAssociationsCompleted() {
    let isCompleted = true;
    for (const checklist of this.prvdrAssociations) {
      if (checklist.checklistStatus != 'C') {
        isCompleted = false;
        break;
      }
    }

    return isCompleted;
  }

  getProviderAssoc(program_code: string, leadId: any) {
    this.enrollmentDataService.fetchProviderAssociations(program_code, leadId).subscribe((response: any) => {
      console.log(response);
    })
  }

  async getGridHeaders() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          this.entry === 'participantEnrollment' ? STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS : STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_HEADERS, this.entry
        );
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
      }
    } catch (e) {
      this.logger.debug('Communication logs - Error in getting column data', e);
    }
  }

  getProviderData(providerCode: string) {
    return this.associationDetailsData[providerCode] || [];
  }

  onRadioChange(controlName: string, value: string) {
    if (value === 'Yes') {
      this.referralDataService.setFlowForAssociation({ val: true, flow: controlName });
    }
  }

  add(control: string) {
    this.referralDataService.setFlowForAssociation({ val: true, flow: control });
  }

  fieldsUpdated($event: any) {
    console.log($event);
  }

  action(event: { action: string; data: any; }) {
    if (event.action == 'view') {
      this.selectedparticipant = event.data;
      this.handleParticipantAssociationSelection(event.data)
    }
  }

  handleAssociationCheckListClick(form: any) {
    this.selectedForm = form;
    this.showPdfViewerModal = true;
    this.modalBody.pdfViewerModal = form.formDesc;
    this.loadPDF(form, true, this.selectedparticipant ? this.selectedparticipant.participantPplId : this.associatedPPLId);
  }

  handleCheckListClick(form: any) {
    // Self checklist form → not a linked Employer ⇄ Provider form.
    this.selectedLinkedMode = null;
    this.selectedLinkedRow = undefined;
    this.selectedForm = form;
    const currentuser = this.selectedForm.details.filter((d: any) => d.associationId == -1);
    this.selectedProviderType = currentuser.length > 0 ? currentuser[0].type : '',

      this.showPdfViewerModal = true;
    this.modalBody.pdfViewerModal = form.formDesc;
    this.loadPDF(form, this.selectedparticipant ? true : false, this.selectedparticipant ? this.selectedparticipant.participantPplId : this.associatedPPLId);
  }

  handleParticipantAssociationSelection(selectedParticipant: any) {
    // Participant association → not a linked Employer ⇄ Provider form.
    this.selectedLinkedMode = null;
    this.selectedLinkedRow = undefined;
    this.showAssociationModal = true;
    this.modalBody.associationModal = 'Participant Association - ' + selectedParticipant.participantFirstName + ' ' + selectedParticipant.participantLastName + ' (' + selectedParticipant.participantPplId + ')';
    this.selectedParticipantId = selectedParticipant.participantId;
    this.selectedProviderType = selectedParticipant.providerType;

    this.checkListService.getChecklistForParticipantAssociation(this.program?.program_code, selectedParticipant.providerId, selectedParticipant.participantId, selectedParticipant.providerType).subscribe((data: any) => {
      if (data.responsedata) {
        const checklist: ChecklistResponse = data.responsedata;
        this.associatedPPLId = checklist.pplId;
        selectedParticipant.providerPPLID = checklist.pplId;
        this.providerAssociationChecklist = this.checklistHelperService.buildChecklistDataForProvider(this.filterHiddenItems(checklist.checkList), selectedParticipant, false, false);
        this.providerAssociationChecklist.forEach(group => {
          group.isActive = true;
          this.toggleCollapsePanel(group, true);
        });
      }
    });
  }

  handleAssociationModalCancel() {
    this.showAssociationModal = false;
    this.associatedPPLId = undefined;
    this.providerAssociationChecklist = undefined;
    this.selectedParticipantId = undefined;
    this.selectedProviderType = undefined;
    this.selectedparticipant = undefined;
  }

  handlePdfViewerModalCancel() {
    this.showPdfViewerModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
  }


  saveChecklist() {
    const checklistSaveResponse = this.generateSaveChecklistResponses(this.checklistData, -1);
    const payload = {
      type: "provider",
      checklistItems: checklistSaveResponse.filter(e => e != null)
    };
    this.checkListService.saveChecklist(this.program?.program_code,
      this.leadId || '',
      false, payload).subscribe(response => {
        console.log(response, 'response')
        this.getChecklist(true);
        this.getAssociationDetails();
      });
  }

  saveChecklistForParticipant() {
    if (this.providerAssociationChecklist && this.selectedParticipantId) {
      const checklistSaveResponse = this.generateSaveChecklistResponses(this.providerAssociationChecklist, this.selectedParticipantId);
      const payload = {
        type: "participantProvider",
        checklistItems: checklistSaveResponse.filter(e => e != null)
      };
      this.checkListService.saveChecklistForParticipantAssociation(this.program?.program_code,
        this.leadId || '',
        this.selectedParticipantId, this.selectedProviderType || '', payload).subscribe(response => {
          console.log(response, 'response')
          if (this.selectedparticipant) {
            this.handleParticipantAssociationSelection(this.selectedparticipant);
          }

          this.getAssociationDetails();
        });
    }
  }

  // Employer ⇄ Provider "Save Checklist" payload item shape:
  // { checklistItemId, checklistDetailId, itemValue, fromDate, toDate }
  private generateLinkedChecklistItems(data: ChecklistGroup[]): any[] {
    const checklist: any[] = [];
    const pushItems = (group: ChecklistGroup) => {
      (group.items ?? []).forEach((i: any) => {
        checklist.push({
          checklistItemId: i.checklistItemId,
          checklistDetailId: i.checklistItemDetailId,
          itemValue: i.value,
          fromDate: i.fromDate ?? '',
          toDate: i.toDate ?? ''
        });
      });
    };
    data.forEach(group => {
      (group.children ?? []).forEach(firstChild => {
        pushItems(firstChild);
        (firstChild.children ?? []).forEach(secondChild => pushItems(secondChild));
      });
    });
    return checklist;
  }

  generateSaveChecklistResponses(data: ChecklistGroup[], participantId: number) {
    const checklist: any[] = [];
    data.forEach(e => {
      if (e.children && e.children.length > 0) {
        e.children.forEach(firstChild => {
          this.generateEachChecklistItemResponse(firstChild, checklist, participantId);

          firstChild.children.forEach(secondChild => {
            this.generateEachChecklistItemResponse(secondChild, checklist, participantId);
          })
        })
      }
    });

    return checklist;
  }

  generateEachChecklistItemResponse(e: ChecklistGroup, checklist: any[], participantId: number) {
    if (e.items && e.items.length > 0) {
      e.items.forEach(i => {
        const currentuser = i.details.filter(d => d.associationId == -1);
        checklist.push(new Object({
          checklistId: i.checklistItemId,
          checklistDetailId: i.checklistItemDetailId,
          value: i.value,
          fromDate: i.fromDate,
          toDate: i.toDate,
          participantId: participantId,
          providerId: this.leadId,
          providerType: currentuser.length > 0 ? currentuser[0].type : '',
          associationId: i.details.filter(d => d.associationId != -1).map(d => d.associationId),
        }));
      });
    }
  }

  loadPDF(form: ChecklistItem, isAssociation: boolean, pplId: string) {
    this.showSignature = form.formStatus == 'C';

    this.checkListService.getPDF(this.program?.program_code, form.formMasterId, 'eng').subscribe((response: HttpResponse<Blob>) => {
      console.log('pdf response' + response);
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
        console.log('blob file' + this.pdfFile);
      }
    });

    this.loadPDFData(form, isAssociation, pplId);
  }

  // For linked (Employer ⇄ Provider) checklist forms, send [{IR, prvPplId},{EMP, empPplId}] as
  // prtcpntPrvdrIdAndTypes instead of the participant PTC remap. Undefined for self/association.
  get linkedFormEntities(): { userType: string; primaryId: string }[] | undefined {
    if (!this.selectedLinkedMode || !this.selectedLinkedRow) return undefined;
    return [
      { userType: 'IR', primaryId: this.selectedLinkedRow.prvPplId },
      { userType: 'EMP', primaryId: this.selectedLinkedRow.empPplId },
    ];
  }

  loadPDFData(form: ChecklistItem, isAssociation: boolean, pplId: string) {
    this.checkListService.getFormData(this.program?.program_code,
      form,
      "provider", pplId || '', '', isAssociation, this.linkedFormEntities).subscribe(response => {
        console.log(response, 'response')
        if (response?.responsedata) {
          this.pdfConfig = {
            fields: response?.responsedata.Form_Fields,
            form_description: '',
            form_id: form.formMasterId + '',
            form_name: form.form_name,
            is_mandatory: false
          };
        }
      });
  }

  isPanelActive(group: ChecklistGroup): boolean {
    return group.isActive;
  }

  hideAll() {
    this.checklistData.forEach(group => {
      group.isActive = false;

      this.toggleCollapsePanel(group, false);
    });

    this.toggleCollapsePanel(this.prvdrAssociations, false);
  }

  expandAll() {
    this.checklistData.forEach(group => {
      group.isActive = true;

      this.toggleCollapsePanel(group, true);
    });

    this.toggleCollapsePanel(this.prvdrAssociations, true);
  }

  toggleCollapsePanel(group: ChecklistGroup, activate: boolean) {
    group.isActive = activate;
    if (group.children && group.children.length > 0) {
      group.children.forEach(c => {
        this.toggleCollapsePanel(c, activate);
      })
    }
  }
}
